var $3aff8d1b1fa24532$exports = {};
$3aff8d1b1fa24532$exports = {
    "collapse": `Colapsar`,
    "columnResizer": `Redimensionador de coluna`,
    "drag": `Arrastar`,
    "expand": `Expandir`,
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`,
    "resizeColumn": `Redimensionar coluna`,
    "sortAscending": `Ordenar por ordem ascendente`,
    "sortDescending": `Ordenar por ordem decrescente`
};


export {$3aff8d1b1fa24532$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
